import {
  createTraining,
  updateTraining,
  deleteTraining,
  getTrainings,
  getTrainingById,
  purchaseTraining,
  hasUserPurchasedTraining,
  getUserPurchasedTrainings,
  CONTENT_TYPES,
  TRAINING_CATEGORIES
} from '../components/TrainingComponents/training';

/**
 * Service pour la gestion des formations
 */
export {
  // Types et catégories
  CONTENT_TYPES,
  TRAINING_CATEGORIES,

  // Fonctions d'administration
  createTraining,
  updateTraining,
  deleteTraining,
  getTrainings,
  getTrainingById,

  // Fonctions utilisateur
  purchaseTraining,
  hasUserPurchasedTraining,
  getUserPurchasedTrainings
};

/**
 * Obtient l'étiquette lisible pour un type de contenu
 * @param {string} contentType - Type de contenu (pdf, book, video)
 * @returns {string} - Étiquette lisible
 */
export const getContentTypeLabel = (contentType) => {
  const labels = {
    [CONTENT_TYPES.PDF]: 'PDF',
    [CONTENT_TYPES.BOOK]: 'Livre',
    [CONTENT_TYPES.VIDEO]: 'Vidéo'
  };
  return labels[contentType] || 'Inconnu';
};

/**
 * Obtient l'étiquette lisible pour une catégorie
 * @param {string} category - Catégorie (course=Modules, td=Cas Pratique, tp=Autres, referentiels=Référentiels, infos_alertes=Infos alertes)
 * @returns {string} - Étiquette lisible
 */
export const getCategoryLabel = (category) => {
  const labels = {
    [TRAINING_CATEGORIES.COURSE]: 'Modules',
    [TRAINING_CATEGORIES.TD]: 'Cas Pratique',
    [TRAINING_CATEGORIES.TP]: 'Autres',
    [TRAINING_CATEGORIES.REFERENTIELS]: 'Référentiels',
    [TRAINING_CATEGORIES.INFOS_ALERTES]: 'Infos alertes'
  };
  return labels[category] || 'Autre';
};

/**
 * Obtient l'icône correspondant au type de contenu
 * @param {string} contentType - Type de contenu
 * @returns {string} - Classe d'icône
 */
export const getContentTypeIcon = (contentType) => {
  const icons = {
    [CONTENT_TYPES.PDF]: 'pe-7s-file',
    [CONTENT_TYPES.BOOK]: 'pe-7s-notebook',
    [CONTENT_TYPES.VIDEO]: 'pe-7s-video'
  };
  return icons[contentType] || 'pe-7s-help1';
};

/**
 * Obtient l'icône correspondant à la catégorie
 * @param {string} category - Catégorie
 * @returns {string} - Classe d'icône
 */
export const getCategoryIcon = (category) => {
  const icons = {
    [TRAINING_CATEGORIES.COURSE]: 'pe-7s-study',
    [TRAINING_CATEGORIES.TD]: 'pe-7s-pen',
    [TRAINING_CATEGORIES.TP]: 'pe-7s-science',
    [TRAINING_CATEGORIES.REFERENTIELS]: 'pe-7s-bookmarks',
    [TRAINING_CATEGORIES.INFOS_ALERTES]: 'pe-7s-bell'
  };
  return icons[category] || 'pe-7s-help1';
};

/**
 * Génère le lien approprié pour télécharger ou consulter un contenu
 * @param {Object} training - Données de la formation
 * @returns {string} - URL du contenu
 */
export const getContentUrl = (training) => {
  if (!training || !training.fileUrl) {
    return '#';
  }
  return training.fileUrl;
};
